import http from '../http-common';

class TareaService {
  getByGradeCycle(gradeId, cycleId, notaType) {
    return http.get('/tareas/grade-cycle', {
      params: { grade_id: gradeId, cycle_id: cycleId, nota: notaType }
    });
  }

  getByNota(notaId, notaType) {
    return http.get(`/tareas/nota/${notaId}`, {
      params: { nota_type: notaType }
    });
  }

  create(data) {
    return http.post('/tareas', data);
  }

  updateStudentScore(tareaId, notaId, punteo) {
    return http.post('/tareas/student-score', {
      tarea_id: tareaId,
      nota_id: notaId,
      punteo: punteo
    });
  }

  update(id, data) {
    return http.put(`/tareas/${id}`, data);
  }

  delete(id) {
    return http.delete(`/tareas/${id}`);
  }
}

export default new TareaService();
